module.exports = __webpack_public_path__ + "static/media/2pic.6c9badec.png";